import { render, staticRenderFns } from "./MapeoColumna.vue?vue&type=template&id=5be3f35f&"
import script from "./MapeoColumna.vue?vue&type=script&lang=ts&"
export * from "./MapeoColumna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5be3f35f', component.options)
    } else {
      api.reload('5be3f35f', component.options)
    }
    module.hot.accept("./MapeoColumna.vue?vue&type=template&id=5be3f35f&", function () {
      api.rerender('5be3f35f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/Step/MapeoColumna.vue"
export default component.exports